export enum RecaptchaAction {
    LOGIN_WITH_CREDENTIALS = 'login_with_credentials',
    LOGIN_WITH_GOOGLE = 'login_with_google',
    REQUEST_PASSWORD_RESET = 'request_password_reset',
    RESET_PASSWORD = 'reset_password',
    SIGN_UP_WITH_CREDENTIALS = 'sign_up_with_credentials',
    SIGN_UP_WITH_GOOGLE = 'sign_up_with_google',
}
